export default __webpack_public_path__ + "static/media/micOff.27d6be20.svg";